import * as React from "react"
import { SEO } from "gatsby-plugin-seo";
import { gsap, Power3 } from "gsap";
import { SplitText } from "gsap/SplitText"
import pimage from "../images/particles.jpg";
import pimage2 from "../images/bubble.jpg";
import Footer from "../components/Footer";
import ProjectCanvas from "../components/ProjectCanvas";
import nextprojectSVG from "../images/next-project.svg";
import customNav from "../components/customNav";
import StarSVG from "../../static/svg/star.inline.svg";

var imagesLoaded = require('imagesloaded');
gsap.registerPlugin(SplitText);


//nav
let siteNav = new customNav();




class PlaygroundPage extends React.Component {

    constructor(props) {
        super(props);

        this.loadImagesHandler = this.loadImages.bind(this);
    }

    componentWillUnmount() {
        window.removeEventListener("fontsLoaded", this.loadImagesHandler);
        this.canvas.destroy();
    }

    initAni() {

        if (typeof window.ss !== 'undefined') {
            window.ss.update();
        }

        setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
        },100);




        let title = new SplitText('.project__title-l', {type: "chars"});


        const scrollLetters = title.chars
        let randomValues = []

        scrollLetters.forEach(letter => {
            const val = Math.random()
            randomValues.push(val)
        })

        function randomLetterScroll() {

            if (document.querySelector(".project__title") != null) {

                const distance = document.querySelector(".project__top").getBoundingClientRect().top
                scrollLetters.forEach((letter, index) => {

                    if (
                        letter.getBoundingClientRect().top < window.innerHeight + 200 &&
                        letter.getBoundingClientRect().top + letter.clientHeight > -200
                    ) {

                        let myVal = randomValues[index];

                        gsap.to(letter,  {
                            duration: 1,
                            y: `${Math.abs(distance * myVal / 15)}px`,
                            overwrite: 'auto'
                        })

                    }
                })

                window.addEventListener('scroll', randomLetterScroll);
            }
        }

        if (window.matchMedia('(min-width:480px)').matches) {
            randomLetterScroll();
        }

        window.ss.on('scroll', (args) => {
            window.dispatchEvent(new Event('scroll'));
            if (args.scroll.y > 104) {
                document.querySelector('.site__scroll').classList.add('scrolled');
            } else {
                document.querySelector('.site__scroll').classList.remove('scrolled');
            }
        });


        const introTimeline = new gsap.timeline({paused: true});

        introTimeline.set(".home__title-col", { perspective: 200,})
        introTimeline.set(".playg__intro-wrap", { perspective: 200,})






        var aniP = {
            opacity: 0,
            duration: 1.0,
            y: 150,
            scaleY: 2,
            stagger: 0.15,
            transformOrigin: "0% 0% 0%",
            rotation: 15,
            rotationX: -25,
            ease: Power3.easeInOut,
            clearProps: true
        }

        introTimeline
            .add('start')
            .from('.project__title',aniP,'start')
            .from('.playg__intro',aniP,'start')
            .from('.site__canvas',{
                opacity: 0,
                duration: 1,
                delay: .5,
                ease: Power3.easeInOut,
            },'start')
            .add(function () {
                window.dispatchEvent(new Event('resize'));
            });



        setTimeout(function () {
            introTimeline.play();
            console.log('go ani go')

        },100);


    }

    loadImages() {
        const preloadImages = new Promise((resolve, reject) => {
            imagesLoaded(document.querySelectorAll("img"), { background: true }, resolve);
        });
        let allDone = [preloadImages];



        Promise.all(allDone).then(()=>{

            let targ = document.querySelector('.site__canvas');
            this.canvas = new ProjectCanvas(targ);
            this.canvas.init();

            this.initAni()

            gsap.to('.site__canvas-wrap', {
                duration: 0.5,
                opacity: 1,
                delay: .5
            });

            gsap.to('main', {
                duration: 0.5,
                opacity: 1,
                delay: .5
            });

            document.querySelector('.loader').classList.add('ready');

            let globalTimeline = new gsap.timeline();

            globalTimeline.to('.loader', {
                duration: .5,
                opacity: 0
            })
                .add(function () {

                    document.querySelector('.loader').style.display = 'none';
                    document.querySelector('.site__nav').classList.add('show');
                    document.querySelector('.site__mode').classList.add('show');
                    document.querySelector('.site__scroll').classList.add('show');


                })




        });
    }

    componentDidMount() {

        if (typeof window !== "undefined") {

            if (!this.props.firstAppLoad) {
                console.log('index - app already inizialized')
                this.loadImages();
            }

            //ho finito di montare il layout
            window.addEventListener('fontsLoaded', this.loadImagesHandler, false);

            document.getElementById('site__mode').addEventListener('click',function (e) {

                e.preventDefault();

                if (document.body.classList.contains('dark-mode')) {
                    this.canvas.setTextureDark();
                } else {
                    this.canvas.setTextureLight();
                }

            }.bind(this));


        }
    }

    render() {

        return(
            <>
                <SEO title="Playground - Luca Nardi Portfolio 2021" description="Playground - Luca Nardi Portfolio 2021" pagePath="playground" />
                <div className="project__top">
                    <div className="container-fluid h-100">
                        <div className="row h-100 align-items-center justify-content-center">
                            <div className="col-12 home__title-col p-0 ">
                                <h1 className="home__title playg__mtitle home__title--7 m-0 project__title text-center">
                                    <div className="project__title-l">THIS IS MY</div>
                                    <div className="project__title-l">PLAYGROUND</div>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-8 playg__intro-wrap">
                            <div className="playg__intro">
                                <span>the playground. A digital space.</span>
                                I tried to picture designs as it implemented through the interactions.
                                What do they look like? UI, UX? Were the visuals like? I kept dreaming of a world I thought I'd never see. And then, one day... I got in.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row align-items-center playg__pro">
                        <div className="col-12 col-lg-6 offset-xl-1 ">
                            <div className="playg__img">
                                <div className="position-relative">
                                    <img className="img-fluid invisible" src={pimage} alt="Project" />
                                    <img data-scroll="" data-scroll-speed="0.25" data-scroll-class="in-view" className="img-fluid canvas-image invisible" src={pimage} alt="Project" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-5 col-xl-4 text-lg-right " data-scroll="" data-scroll-speed="-0.25">
                            <div className="playg__c">
                                <div className="row justify-content-center">
                                    <div className="col-auto">
                                        <StarSVG />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-10">
                                        <h3 className="playg__title">
                                            Put particles in scene apply them to a model and make some noise
                                        </h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-10 offset-2">
                                        <div className="playg__desc">Thanks to Awwwards and Fabio with this course i will be able to pickup a model and turn it into something spectacular.</div>
                                        <a className="playg__link fs" onClick={e => { e.preventDefault(); siteNav.nav('/particles/'); }} href="">launch</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center playg__pro">
                        <div className="col-12 col-lg-6 order-lg-1">
                            <div className="playg__img">
                                <div className="position-relative">
                                    <img className="img-fluid invisible" src={pimage2} alt="Project" />
                                    <img data-scroll="" data-scroll-speed="0.25" data-scroll-class="in-view" className="img-fluid canvas-image invisible" src={pimage2} alt="Project" />
                                </div>

                            </div>
                        </div>
                        <div className="col-12 col-lg-5 col-xl-4 offset-lg-1 order-lg-0" data-scroll="" data-scroll-speed="-0.25">
                            <div className="playg__c playg__c--r">
                                <div className="row justify-content-center">
                                    <div className="col-auto">
                                        <StarSVG />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-10">
                                        <h3 className="playg__title">
                                            Video reel wrapped in a floating bubble changing its shape dynamically
                                        </h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-10 offset-2">
                                        <div className="playg__desc">
                                            Using a video as texture i placed it in my geometry passing it as uniform to my shader. then i morphed the geometry in the render function by adding some noise to the vertices.
                                        </div>
                                        <a className="playg__link fs" onClick={e => { e.preventDefault(); siteNav.nav('/bubble-reel/'); }} href="">launch</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-auto">
                            <div className="playg__end">LIST IN PROGRESS</div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">
                            <div className="project__end"></div>
                        </div>
                    </div>
                    <div className="row">
                        <a href="/lorrive/" onClick={e => { e.preventDefault(); siteNav.nav('/lorrive/'); }} className="col-12 p-0 project__next-wrap" data-scroll data-scroll-class="in-view">
                            <img src={nextprojectSVG} className="img-fluid project__next invisible" alt="" /><br />
                        </a>
                    </div>
                </div>

                <Footer />

            </>
        )
    }
}

export default PlaygroundPage
